// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Oajsf","modalFooterButton":"ModalNotes_modalFooterButton__2fPkf"};